import React from 'react';
import { Report as ReportShape } from '../../shapes/report';
import ReportHeader from './report-header';
import ReportSummary from './report-summary';
import ReportBreakdown from './report-breakdown';
import { generatePDF, downloadPDF as downloadPDFToDevice } from '../../services/pdf';
import Classes from './styles/index';
import { Button } from 'reactstrap';
import { translate } from 'react-i18next';

class Report extends React.Component {

  state = {
    generatingPDF: false
  };

  downloadPDF = async () => {
    await new Promise(resolve => this.setState({
      generatingPDF: true
    }, resolve));
    try {
      const base64PDFUri = await generatePDF(this.reference);
      downloadPDFToDevice(base64PDFUri, `rewards-report-${Date.now()}.pdf`);
    } catch(e) {
      alert('Failed to generate PDF!');
      console.warn(e);
    }
    await new Promise(resolve => this.setState({
      generatingPDF: false
    }, resolve));
  };

  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <div ref={reference => this.reference = reference} className={Classes.report}>
          <ReportHeader report={this.props.report} />
          <br />
          {
            this.props.report.summary ? (
              <React.Fragment>
                <ReportSummary summary={this.props.report.summary} />
                <br />
              </React.Fragment>
            ) : null
          }
          <ReportBreakdown breakdown={this.props.report.breakdown} totals={this.props.report.totals} />
        </div>
        <div className={`d-print-none ${Classes.reportFooterActions}`}>
          <Button onClick={this.downloadPDF} disabled={this.state.generatingPDF} color="primary" size="sm">{this.state.generatingPDF ? 'Generating PDF...' : 'Download PDF'}</Button>
          <br />
        </div>
      </React.Fragment>

    )
  }

}

Report.propTypes = {
  report: ReportShape.isRequired
};

export default translate(['report'])(Report);



// WEBPACK FOOTER //
// ./src/views/report/index.js